const axios = require("axios");

function setSessionItem(key, value) {
  sessionStorage.setItem(key, value);
}

function getSessionItem(key) {
  const sessionItem = sessionStorage.getItem(key);
  return sessionItem;
}

async function create_chat_logs(messages) {
  var message_history = "CHAT HISTORY:";
  var message_summary = "";
  var sender = "";
  var timeSent;
  var summaryResponse = "";
  for (const message of messages) {
    // don't include notifications
    if (message.type == "text") {
      if (message.position == "left") {
        try {
          if (message.user.avatar == "./img/genesys.svg") {
            sender = "Genesys Agent: ";
          }
        } catch (error) {
          sender = "Mark (Virtual Agent): ";
        }
      } else {
        sender = "User: ";
      }
      timeSent = new Date(message.createdAt);
      message_history =
        message_history +
        "\n" +
        sender +
        "\n" +
        message.content.text +
        "\n" +
        timeSent.toLocaleTimeString() +
        "\n";
    }
  }

  console.log({ message_history });
  try {
    const headers = {
      "Content-Type": "application/json",
    };
    message_summary = await axios.post(
      "https://us-central1-dialogflowcx-agents.cloudfunctions.net/gpt-summerizer",
      { key: "1283jfdlkfa!@#@!#FSafsdafjl1231", transcript: message_history },
      {
        headers: headers,
      }
    );
    console.log(
      " message_summary: " + JSON.stringify(message_summary.data.summary)
    );

    summaryResponse =
      "Summary of Interaction: \n" +
      JSON.stringify(message_summary.data.summary)
        .substring(1, JSON.stringify(message_summary.data.summary).length - 1)
        .replaceAll("\\n", "\n");
  } catch (error) {
    console.log("Error at message_summary: " + error);
  }

  message_history = message_history + "\n" + summaryResponse;
  console.log("message_history: " + message_history);
  return message_history;
}

function csv_create_chat_logs(messages, env) {
  var message_history = "Sender:, Timestamp:, Message:";
  var sender = "";
  var timeSent;
  for (const message of messages) {
    // don't include notifications
    if (message.type == "text") {
      if (message.position == "left") {
        try {
          if (message.user.avatar == "./img/genesys.svg") {
            sender = "Genesys Agent: ";
          } else {
            sender = `${env.EN.name} (Virtual Agent): `;
          }
        } catch (error) {
          sender = `${env.EN.name} (Virtual Agent): `;
        }
      } else {
        sender = "User";
      }
      timeSent = new Date(message.createdAt);
      message_history =
        message_history +
        "\n" +
        sender +
        "," +
        timeSent.toLocaleTimeString() +
        ',"' +
        message.content.text +
        '"';
    } else if (message.type == "divider" && message.content.text == "reset") {
      message_history =
        message_history + "\n\n" + "Chat Bot Session Reset" + "\n";
    }
  }
  return message_history;
}

function get_language(startingLanguage) {
  var language;
  if (!getSessionItem("language")) {
    language = startingLanguage;
  } else {
    language = getSessionItem("language");
  }
  return language;
}

function get_fontSize() {
  var fontSize;
  if (!getSessionItem("fontSize")) {
    console.log("Default size not found, defaulting to small")
    fontSize = "Small";
    sessionStorage.setItem("fontSize", fontSize)
  } else {
    fontSize = getSessionItem("fontSize");
  }
  return fontSize;
}

// determines if we're sending messages to DF or genesys
function get_chatType() {
  var chatType;

  if (getSessionItem("chatType")) {
    chatType = getSessionItem("chatType");
  } else {
    chatType = "df";
    setSessionItem("chatType", chatType);
  }
  return chatType;
}

export {
  setSessionItem,
  getSessionItem,
  create_chat_logs,
  get_language,
  get_fontSize,
  csv_create_chat_logs,
  get_chatType
};
